// extracted by mini-css-extract-plugin
export default {"messageContainer":"Message_messageContainer__YAuls","messageBox":"Message_messageBox__vQVjg"};